import React from "react";
import { Link } from "react-router-dom";
import ServiceData from "../../data/service/ServiceMain.json";
import { slugify } from "../../utils";

const AllData = ServiceData;

const ServicePropOne = ({ colSize, serviceStyle, itemShow, marginTop }) => {
  const topMargin = (index) => {
    if (marginTop === "yes") {
      if (index === 0) {
        return "mt--200 mt_md--0";
      } else if (index === 1) {
        return "mt--100 mt_md--0";
      } else {
        return "mt--0";
      }
    } else {
      return "";
    }
  };

  return (
    <>
      {AllData.slice(0, itemShow).map((data, index) => (
        <div className={`${colSize} ${topMargin(index)} pb-2`} key={index}>
          <div className={`services-grid ${serviceStyle}`}>
            <div className="thumbnail">
              <img src={process.env.PUBLIC_URL + data.image} alt="icon" />
            </div>
            <div className="content">
              <h5 className="title">
                <Link
                  to={
                    process.env.PUBLIC_URL +
                    `/service-details/${slugify(data.title)}`
                  }
                >
                  {data.title}
                </Link>
              </h5>
              <p>{data.description}</p>
              <Link
                to={
                  process.env.PUBLIC_URL +
                  `/service-details/${slugify(data.title)}`
                }
                className="more-btn"
              >
                Find out more
              </Link>
            </div>
          </div>
        </div>
      ))}
      <div className={`${colSize} ${topMargin(0)}`}>
        <div className={`services-extra ${serviceStyle}`}>
          <div className="subtitle">
            <h5>Can't find what you're looking for?</h5>
          </div>
          <p>We offer custom services tailored to your needs.</p>
          <Link
            to={process.env.PUBLIC_URL + "/contact"}
            className="axil-btn btn-fill-primary btn-medium"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </>
  );
};

//process.env.PUBLIC_URL + `/service-details/${slugify(data.title)}`

export default ServicePropOne;
